import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-800 transition-colors mb-8">
        <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
      </Link>

      <h1 className="text-3xl font-outfit font-extrabold text-slate-900 mb-2">Impressum</h1>
      <p className="text-slate-400 text-sm mb-10">Angaben gemäß § 5 TMG</p>

      <div className="space-y-8 text-slate-700 text-sm leading-relaxed">

        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-amber-800 text-sm">
          <strong>Hinweis:</strong> Bei dealzauber.de werden Angebote manuell recherchiert und von der Community bewertet.
          Es gibt keine Garantie, dass die angezeigten Angebote aktuell oder noch verfügbar sind.
          Bei Problemen mit einem Produkt wende Dich bitte direkt an den jeweiligen Händler.
        </div>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">Technisch und inhaltlich verantwortlich</h2>
          <p>
            Kenan Artiran & Mustafa Emirler<br />
            Parksiedlung Spruch 86<br />
            12349 Berlin<br />
            Deutschland
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">Kontakt</h2>
          <p>E-Mail: <a href="mailto:admin@dealzauber.de" className="text-[#A259FF] hover:underline">admin@dealzauber.de</a></p>
          <p className="mt-1">Website: <a href="https://www.dealzauber.de" className="text-[#A259FF] hover:underline">www.dealzauber.de</a></p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)</h2>
          <p>
            Kenan Artiran<br />
            Parksiedlung Spruch 86<br />
            12349 Berlin
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">Affiliate-Hinweis</h2>
          <p>
            Wenn Du auf dealzauber.de auf einen Deal klickst und anschließend etwas kaufst, erhalten wir unter Umständen eine
            Provision vom jeweiligen Anbieter. Dadurch können wir unsere Plattform weiterhin kostenlos anbieten, ohne unsere
            Unabhängigkeit zu gefährden. Ob wir eine Provision erhalten oder nicht, hat keinen Einfluss auf die Temperatur
            eines Deals — diese wird allein von der Community bestimmt.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">1. Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
            Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
            übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">2. Haftung für Links</h2>
          <p>
            Bei direkten oder indirekten Verweisen auf fremde Webseiten („Hyperlinks"), die außerhalb unseres
            Verantwortungsbereiches liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten,
            in dem wir von den Inhalten Kenntnis haben und es uns technisch möglich und zumutbar wäre, die Nutzung im Falle
            rechtswidriger Inhalte zu verhindern. Wir erklären ausdrücklich, dass zum Zeitpunkt der Linksetzung
            keine illegalen Inhalte auf den verlinkten Seiten erkennbar waren.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">3. Urheberrecht</h2>
          <p>
            Die durch uns erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
            Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
            Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors. Beiträge Dritter sind als solche gekennzeichnet.
          </p>
        </section>

        <section>
          <h2 className="font-outfit font-bold text-base text-slate-900 mb-3">4. Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#A259FF] hover:underline">
              https://ec.europa.eu/consumers/odr/
            </a>
          </p>
          <p className="mt-2">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </section>

      </div>
    </div>
  );
}
